import {combineReducers} from "redux"
import earningHistory from "./earningHistory"
import workload from "./workload"
import ticketsPayment from "./ticketsPayment"
import validationLedger from "./validationLedger"

const statisticsReducer = combineReducers({
        earningHistory,
        workload,
        ticketsPayment,
        validationLedger
    }
)

export default statisticsReducer